"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PCPHelper = exports.stateActionBuilder = void 0;
var PCPStateActionBuilder_1 = require("./PCPStateActionBuilder");
function stateActionBuilder(pinRow) {
    return new PCPStateActionBuilder_1.PCPStateActionBuilder(pinRow);
}
exports.stateActionBuilder = stateActionBuilder;
var PCPHelper = /** @class */ (function () {
    function PCPHelper() {
        var _this = this;
        this.pinCallbacks = undefined;
        this.getAllFilteredRows = function (allRows) {
            var validRows = [];
            allRows.forEach(function (eachRow) {
                var userRowData = _this.userRowData(eachRow);
                // check the validity of user provided data
                if (userRowData && _this.isRowValid(userRowData)) {
                    validRows.push(userRowData);
                }
            });
            return validRows;
        };
        this.isRowValid = function (eachRow) {
            if ((eachRow === null || eachRow === void 0 ? void 0 : eachRow.name) &&
                (eachRow === null || eachRow === void 0 ? void 0 : eachRow.module) &&
                (eachRow === null || eachRow === void 0 ? void 0 : eachRow.function) &&
                (eachRow === null || eachRow === void 0 ? void 0 : eachRow.direction) &&
                (eachRow === null || eachRow === void 0 ? void 0 : eachRow.behaviour)) {
                return true;
            }
            else {
                return false;
            }
        };
        this.userRowData = function (eachRow) {
            var _a;
            var eachrowret = eachRow;
            if ((_a = _this.pinCallbacks) === null || _a === void 0 ? void 0 : _a.getRowData) {
                eachrowret = _this.pinCallbacks.getRowData(__assign({}, eachRow));
            }
            return eachrowret;
        };
        this.getAllRows = function () {
            var _a, _b, _c, _d, _e;
            var pinRows = (_d = (_c = (_b = (_a = _this.pinCallbacks) === null || _a === void 0 ? void 0 : _a.getPinsData) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.rows) !== null && _d !== void 0 ? _d : [];
            var userdata = {};
            if ((_e = _this.pinCallbacks) === null || _e === void 0 ? void 0 : _e.getCompletePinData) {
                userdata = _this.pinCallbacks.getCompletePinData();
                if (userdata && (userdata === null || userdata === void 0 ? void 0 : userdata.rows)) {
                    pinRows = userdata.rows;
                }
            }
            return pinRows;
        };
        this.getData = function () {
            var retData = {
                rows: _this.getAllFilteredRows(_this.getAllRows()),
            };
            return retData;
        };
    }
    PCPHelper.prototype.stateActionBuilder = function (pinRow) {
        return stateActionBuilder(pinRow);
    };
    PCPHelper.prototype.setCallbacks = function (callbacks) {
        this.pinCallbacks = callbacks;
    };
    return PCPHelper;
}());
exports.PCPHelper = PCPHelper;
//# sourceMappingURL=PCPHelper.js.map